import { Button, Grid } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useLocation, useNavigate } from 'react-router-dom';

import TaskGradeEditPageStore from 'pages/EmployeeDetailPage/store/TaskGradeEditStore';
import { useMediaQueryState } from 'hooks/useMediaQueryState';

interface Props {
  pageStore: TaskGradeEditPageStore;
}
function TaskGradeEditBottom(props: Props) {
  const { pageStore } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile, isOutlook } = useMediaQueryState();
  const PLUGIN_MAILS_PATH = '/plugin/mails';
  const PLUGIN_TEAMS_PATH = '/plugin/teams';

  const handleClickCancel = () => {
    let pathname = PLUGIN_TEAMS_PATH;
    if (location.pathname.includes(PLUGIN_MAILS_PATH)) {
      pathname = PLUGIN_MAILS_PATH;
    }
    navigate(pathname + location.search, {
      state: { employee: toJS(pageStore.employee) },
    });
  };

  return (
    <Grid container gap={1} justifyContent={'center'}>
      <Button
        style={{
          background: '#ffffff',
          border: '1px solid #dddddd',
          borderRadius: '25px',
          fontWeight: 500,
          fontSize: isOutlook ? '15px' : '16px',
          lineHeight: '16px',
          padding: isOutlook ? '12px 30px' : '17px 55px',
          boxShadow: 'none',
          cursor: 'pointer',
          color: '#000000',
          textTransform: 'unset',
        }}
        variant='contained'
        onClick={handleClickCancel}
      >
        Cancel
      </Button>
      <Button
        style={{
          background: '#2281D0',
          borderRadius: '25px',
          color: '#ffffff',
          fontWeight: 500,
          fontSize: isOutlook ? '15px' : '16px',
          lineHeight: '16px',
          padding: isOutlook ? '12px 30px' : '17px 55px',
          boxShadow: 'none',
          textTransform: 'unset',
        }}
        type='submit'
        variant='contained'
      >
        Save
      </Button>
    </Grid>
  );
}

export default observer(TaskGradeEditBottom);
